<template>
  <div>
    <!-- MODAL TRANSAKSI BARU -->
    <button @click="aktifModalTransaksi" 
    v-if="pilih=='adminapotek'"
     type="button" class="btn btn-sm btn-style9 rounded-circle" 
    style="position:fixed;bottom:55px;right:20px;z-index:100;height:40px;width:40px;">+</button>
    <div v-if="modaltransaksi" @click="modaltransaksi=false" style="position:fixed;width:100vw;height:100vh;left:0;top:0;z-index:100;"></div>
    <div v-if="modaltransaksi" style="position: fixed;top: 50%;left: 50%;transform: translateX(-50%) translateY(-50%);z-index:105;min-width:50vw;">
      <div class="rounded-lg shadow p-3 bg-white animate__animated animate__bounceIn">
          <form action="" @submit.prevent="tambahTransaksiBaru">
            <span class="font-semibold italic">
              {{vdata.nota}}
            </span>
              <button type="button" class="btn btn-sm btn-dark  float-right" @click="$router.push('/admin/pelanggan')"><span class="typcn typcn-user-add"></span> Tambah Data Pelanggan</button>
              <div class="table-responsive">
                  <table class="table table-sm table-striped table-bordered">
                      <tr>        
                          <td class="capitalize">pelanggan</td>
                          <td class="pl-2 pr-2">:</td>
                          <td>
                            <v-select :options="pelanggans" label="item_data" v-model="vdata.id_pelanggan" :reduce="e => e.id"></v-select>
                          </td>
                      </tr>
                        <tr>        
                          <td class="capitalize"><span class="typcn typcn-pen"></span> Catatan Admin</td>
                          <td class="pl-2 pr-2">:</td>
                          <td>
                              <div class="sm-form">
                              <textarea type="text" id="catatan_admin" name="catatan_admin" rows="2" placeholder="catatan_admin..." class="form-control md-textarea" 
                              v-model="vdata.catatan_admin" ></textarea>
                              </div>
                          </td>
                      </tr>
                  </table>
                </div>
                  <img src="@/static/hospital.png" class="img-fluid float-left " style="height:40px;width:40px;" alt="">
                 <div class="text-right">
                  <button type="submit" class="btn btn-sm btn-dark  text-sm" ><span class="typcn typcn-business-card"></span> Tambah Ticket Transaksi Baru +</button>
              </div>
        </form>
      </div>
    </div>
    <!--  /// MODAL TRANSAKSI BARU -->
      <!-- ================================================================= -->
      <!-- MODAL BAYAR -->
    <div v-if="modalbayar" class="row" style="position:fixed;top:60px;right:10px;z-index:1000;width:100vw;">
        <div class="col-sm-9" @click="modalbayar=false" style="height:100vh;"></div>
        <div class="col-sm-3">
            <div class="bg-white rounded-lg p-3 shadow animate__animated animate__bounceInDown">
                <div class="sm-form ">
                    <label for="nota">Nota</label>
                    <input type="text" disabled id="nota" name="nota" class="form-control form-control-sm" placeholder="nota" v-model="vdata.nota" >
                </div>
                <div class="sm-form ">
                    <label for="uang">Uang : </label>
                    <input type="number" id="uang" name="uang" class="form-control form-control-sm" placeholder="uang" v-model="uang" >
                </div>
                <div class="sm-form">
                <textarea type="text" id="keterangan" name="keterangan" rows="2" placeholder="keterangan..." class="form-control md-textarea" v-model="vdata.keterangan"></textarea>
                </div>
                <hr>
                <p class="">total Rp. {{total}}</p>
                <p>Uang : {{uang}}</p>
                <!-- <button type="button" @click="diskon" :disabled="diskons" class="btn btn-sm btn-primary  ">Apply Diskon</button> -->
                <p v-show="uang-total">Kembalian : {{uang-total}}</p>
                <hr>
                <button type="button" id="btnbayar2" @click="bayar" class="btn btn-sm btn-dark  "><span class="typcn typcn-export"></span> Bayar</button>
            </div>
        </div>
    </div>
      <!-- ================================================================= -->
      <!-- NAVIGATION  -->
      <div class="ml-3 sm:ml-0">
        <br>
        <span class="font-semibold text-lg p-3 mt-5 italic shadow rounded-lg" v-if="pilih=='adminapotek'"><span class="typcn typcn-user"></span> Menu Admin Apotek</span>
        <span class="font-semibold text-lg p-3 mt-5 italic shadow rounded-lg" v-if="pilih=='apoteker'"><span class="typcn typcn-user"></span> Menu Apoteker</span>
        <span class="font-semibold text-lg p-3 mt-5 italic shadow rounded-lg" v-if="pilih=='dokter'"><span class="typcn typcn-user"></span> Menu Dokter</span>
        <span class="font-semibold text-lg p-3 mt-5 italic shadow rounded-lg" v-if="pilih=='nurse'"><span class="typcn typcn-user"></span> Menu Nurse</span>
          <div v-if="$store.state.users.level=='SuperAdmin'" class="row bg-white shadow rounded-t-lg pt-2 mt-5 scrollbarnya items" style="overflow: auto; white-space: nowrap;">
                <div class="col-3" @click="pilih='adminapotek'">
                  <button type="button"  class="btn btn-sm   btn-block" :class="`${pilih=='adminapotek'?'btn-dark':'btn-outline-dark'}`" style="width:100%;">
                    Admin 
                  </button>
                </div>
                <div class="col-3" @click="pilih='apoteker'">
                  <button type="button" class="btn btn-sm   btn-block" :class="`${pilih=='apoteker'?'btn-dark':'btn-outline-dark'}`" style="width:100%;">
                    Apoteker
                  </button>
                </div>
                <div class="col-3" @click="pilih='dokter'">
                  <button type="button" class="btn btn-sm   btn-block" :class="`${pilih=='dokter'?'btn-dark':'btn-outline-dark'}`" style="width:100%;">
                    Dokter
                  </button>
                </div>
                <div class="col-3" @click="pilih='nurse'">
                  <button type="button" class="btn btn-sm   btn-block" :class="`${pilih=='nurse'?'btn-dark':'btn-outline-dark'}`" style="width:100%;">
                    Nurse
                  </button>
                </div>
                <div class="col-12">
                
                </div>
          </div>
          <div class="row bg-white shadow rounded-b-lg p-4 scrollbarnya " style="min-height:60vh;">
            <div class="col-sm-8">
              <!-- LIST TICKET  -->
                <div class="row justify-content-center" v-if="ticket">
                  <!-- FORM UPDATE TRANSASKI NOTA -->
                  <div class="col-md-12">
                    <div class="row">
                      
                      <div class="col-6"  >
                        <div class="shadow rounded-lg p-3 text-sm">
                              <div v-if="pilih=='adminapotek'">
                                <p class="capitalize">Catatan Admin</p>
                                <div class="sm-form" >
                                  <textarea type="text" id="catatan_admin" name="catatan_admin" rows="4"  class="form-control md-textarea" v-model="vdata.catatan_admin"
                                  ></textarea>
                                </div>
                              </div>
                              <div v-if="pilih=='dokter'">
                                <p class="capitalize">Catatan Dokter</p>
                                <div class="sm-form" >
                                  <textarea type="text" id="catatan_dokter" name="catatan_dokter" rows="4"  class="form-control md-textarea" v-model="vdata.catatan_dokter"
                                  ></textarea>
                                </div>
                              </div>
                              <div v-if="pilih=='apoteker'">
                                <p class="capitalize">Catatan Apoteker</p>
                                  <div class="sm-form" >
                                    <textarea type="text" id="catatan_apoteker" name="catatan_apoteker" rows="4"  class="form-control md-textarea" v-model="vdata.catatan_apoteker"
                                    ></textarea>
                                  </div>
                              </div>
                              <div v-if="pilih=='nurse'">
                                <p class="capitalize">Catatan Nurse</p>
                                <div class="sm-form" >
                                  <textarea type="text" id="catatan_nurse" name="catatan_nurse" rows="4"  class="form-control md-textarea" v-model="vdata.catatan_nurse"
                                  ></textarea>
                                </div>
                              </div>
                        </div>
                      </div>
                      <div class="col-6" >
                      <div class="shadow rounded-lg p-3" >
                        <p class="font-semibold">
                        Ticket/Nota : <span class="typcn typcn-business-card"></span> {{vdata.nota}}
                        </p>
                        <select class='form-control' v-model="proses">
                          <option value='1' v-if="pilih=='adminapotek'">Registered > Admin</option>
                          <option value='2' v-if="pilih=='adminapotek'" >Konsul > Dokter</option>  
                          <option value='3' v-if="pilih=='dokter' || pilih=='adminapotek'" >Treatment > Nurse</option>
                          <option value='4' v-if="pilih=='dokter' || pilih=='nurse'" >Treatment Dokter  > Dokter</option>
                          <option value='5' v-if="pilih=='dokter' || pilih=='nurse'" >Buatkan Resep  > Dokter</option>
                          <option value='6' v-if="pilih=='dokter' || pilih=='nurse'" >Menyiapkan Obat > Apoteker</option>
                          <option value='7' v-if="pilih=='dokter' || pilih=='nurse' || pilih=='apoteker'" >Bayar  > Admin</option>
                        </select>
                        <div class="p-3 ">
                          <button type="button" @click="teruskanTransaksi" class="btn btn-sm btn-success float-right"><span class="typcn typcn-arrow-right"></span> Teruskan</button>
                          <button type="button" v-if="pilih=='dokter'" @click="$router.push(`/admin/transaksi/apotek/review?nota=${vdata.nota}`)" class="btn btn-sm btn-dark  ">Review</button>
                        </div>  
                      </div>
                      </div>
                    </div>
                    <div class="shadow rounded-lg p-3 text-sm mt-2">
                        <div class="table-responsive">
                          <table class="table table-sm table-striped table-bordered">
                             <tr v-if="vdata.catatan_admin">        
                                <td class="capitalize">catatan_admin</td>
                                <td class="pl-2 pr-2">:</td>
                                <td>
                                    <div  style="white-space: pre-line;">{{vdata.catatan_admin}}</div>
                                </td>
                            </tr>
                             <tr v-if="vdata.catatan_dokter">        
                                <td class="capitalize">catatan_dokter</td>
                                <td class="pl-2 pr-2">:</td>
                                <td>
                                    <div style="white-space: pre-line;">{{vdata.catatan_dokter}}</div>
                                </td>
                            </tr>
                             <tr v-if="vdata.catatan_apoteker">        
                                <td class="capitalize">catatan_apoteker</td>
                                <td class="pl-2 pr-2">:</td>
                                <td>
                                    <div  style="white-space: pre-line;">{{vdata.catatan_apoteker}}</div>
                                </td>
                            </tr>
                             <tr v-if="vdata.catatan_nurse">        
                                <td class="capitalize">catatan_nurse</td>
                                <td class="pl-2 pr-2">:</td>
                                <td>
                                    <div style="white-space: pre-line;">{{vdata.catatan_nurse}}</div>
                                </td>
                            </tr>
                          </table>
                          <button type="button" @click="$router.push(`/admin/pelanggan/listhistory?pelanggan=${vdata.id_pelanggan}`)" class="btn btn-sm btn-dark  ">Catatan History Pelanggan</button>
                        </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div style="height:50vh;" class="d-flex justify-content-center align-items-center ">
                      <div style="width:100%">
                        <div class="text-center font-semibold text-lg italic">
                         <span class="typcn typcn-business-card"></span> Ticket Flow Aplikasi Apotek
                         <br>
                         <br>
                         <button type="button"  class="btn btn-sm btn-style8  " v-if="pilih=='adminapotek'" @click="aktifModalTransaksi">Tambah Transaksi Baru + </button>
                        </div>
                      </div>
                  </div>
                </div>
            </div>
            <div class="col-sm-4">
                <button type="button" class="btn btn-sm btn-dark ml-1" @click="ubahTicket('latest')"> <span class="typcn typcn-business-card"></span> 
                 Latest</button>
                <button type="button" class="btn btn-sm btn-dark ml-1" @click="ubahTicket('history')"><span class="typcn typcn-business-card"></span> 
                 History</button>
                 <button type="button" class="btn btn-sm btn-style10 ml-1 text-xs " @click="$router.push('/admin/transaksi/apotek/ticketflow')"><span class="typcn typcn-business-card"></span> 
                 Ticket Flow <span class="typcn typcn-arrow-right"></span> </button>
                 <div class="" v-for="(item, index) in transaksiNota" :key="index+'nota'" >
                  <div v-if="transaksiNota.length>0">
                    <!-- LIST TRANSAKSI APOTEK -->
                    <div v-if="ticketType=='latest'">
                      <div v-if="item.proses!='8'">
                        <p class="font-semibold" v-if="index=='0'"><span class="typcn typcn-business-card"></span> List Ticket </p>
                          <div v-if="(pilih=='adminapotek' && item.proses=='1')||(pilih=='adminapotek' && item.proses=='7') ?true:(pilih=='dokter' && item.proses=='2')||(pilih=='dokter' && item.proses=='4')||(pilih=='dokter' && item.proses=='5')?true:(pilih=='nurse' && item.proses=='3')?true:(pilih=='apoteker' && item.proses=='6') "
                          @click="getTicket(item)" class="shadow hover:text-red-400 hover:shadow-lg anim cursor-pointer rounded-lg p-3 text-xs mb-2" >
                            <p class="float-right  font-semibold italic text-gray-500">{{format2(item.tanggal)}}</p>
                            <p class="font-semibold">{{item.nota}}  
                            </p>
                            <hr class="mt-1 mb-1">
                            <div class="float-right">
                              <button type="button" 
                              v-if="item.proses=='1'"
                              @click="hapusTransaksi(item)" class="btn btn-sm btn-danger text-xs ">X</button>
                            </div>
                            <table class="">
                              <tr>
                                <td class="font-semibold">Pelanggan</td>
                                <td class="pl-2 pr-2">:</td>
                                <td class="font-semibold">{{item.pelanggan}}</td>
                              </tr>
                                <tr>
                                <td class="font-semibold">Keterangan</td>
                                <td class="pl-2 pr-2">:</td>
                                <td class="font-semibold">{{item.catatan_admin}}</td>
                              </tr>
                            </table>
                            <button type="button" class="btn btn-sm ml-3 float-right"
                            :class="`${item.proses=='1'?'btn-dark':item.proses=='2'||item.proses=='3'||item.proses=='4'?'btn-warning':item.proses=='5'?'btn-primary':item.proses=='6'?'btn-danger':item.proses=='7'?'btn-success':'btn-style10'}`">
                            <span class="typcn typcn-media-record"></span> {{item.proses=='1'?'Registered':item.proses=='2'?'Konsul':item.proses=='3'?'Treatment':item.proses=='4'?'Treatment Dokter':item.proses=='5'?'Buat Resep':item.proses=='6'?'Menyiapkan Obat':item.proses=='7'?'Bayar':'Selesai'}}
                            </button>
                          </div>
                      </div>
                    </div>
                    <!-- ==================================== -->
                    <div v-else>
                      <div  v-if="item.proses=='8'">
                        <p class="font-semibold" v-if="index=='0'"><span class="typcn typcn-business-card"></span> History Ticket</p>
                          <div 
                          @click="getTicket(item)" class="shadow hover:text-red-400 hover:shadow-lg anim cursor-pointer rounded-lg p-3 text-xs mb-2" >
                            <p class="float-right  font-semibold italic text-gray-500"> {{format2(item.tanggal)}}</p>
                            <div v-if="!item.tanggal">
                              <div class="sm-form ">
                                  <input type="datetime-local" id="tanggal" name="tanggal" class="form-control p-2 rounded-lg shadow" placeholder="tanggal" v-model="updates['tanggal']" >
                              </div>
                              <button type="button" class="btn btn-sm btn-success  " @click="updateTanggal(item)"><span class="typcn typcn-edit"></span></button>

                            </div>
                            <p class="font-semibold">{{item.nota}}  
                            </p>
                            <hr class="mt-1 mb-1">
                            <div class="float-right">
                              <button type="button" 
                              v-if="$store.state.users.level=='SuperAdmin'"
                              @click="hapusTransaksi(item)" class="btn btn-sm btn-danger text-xs ">X</button>
                            </div>
                            <table class="">
                              <tr>
                                <td class="font-semibold">Pelanggan</td>
                                <td class="pl-2 pr-2">:</td>
                                <td class="font-semibold">{{item.pelanggan}}</td>
                              </tr>
                                <tr>
                                <td class="font-semibold">Keterangan</td>
                                <td class="pl-2 pr-2">:</td>
                                <td class="font-semibold">{{item.catatan_admin}}</td>
                              </tr>
                            </table>
                            <button type="button" class="btn btn-sm ml-3 float-right"
                            :class="`${item.proses=='1'?'btn-dark':item.proses=='2'||item.proses=='3'||item.proses=='4'?'btn-warning':item.proses=='5'?'btn-primary':item.proses=='6'?'btn-danger':item.proses=='7'?'btn-success':'btn-style10'}`">
                            <span class="typcn typcn-media-record"></span> {{item.proses=='1'?'Registered':item.proses=='2'?'Konsul':item.proses=='3'?'Treatment':item.proses=='4'?'Treatment Dokter':item.proses=='5'?'Buat Resep':item.proses=='6'?'Menyiapkan Obat':item.proses=='7'?'Bayar':'Selesai'}}
                            </button>
                          </div>
                      </div>
                    </div>
                    <!-- LIST TRANSAKSI APOTEK -->
                  </div>
                  <div v-else>
                    <div style="height:100px;" class="d-flex justify-content-center align-items-center shadow-lg rounded-lg">
                        <div style="width:100%">
                          <p class="text-center">
                            Ticket Kosong !
                          </p>
                        </div>
                    </div>
                  </div>
                </div>
               
            </div>
          </div>
      </div>
      <!-- <div class="mt-2 shadow p-3 rounded-lg" v-if="ticket && (proses=='2' || proses=='3' || proses=='4' || proses=='6' || proses=='7')"> -->
      <div class="mt-2 shadow p-3 rounded-lg" >
        <p class="font-semibold text-sm">Tambahkan Barang/Jasa</p>
        <hr class="mt-1 mb-3">
        <!-- FORM TRANSAKSI KERANJANG -->
        <form  @submit.prevent="submit" >
          <div class="row justify-content-center">
            <div class=" col-sm-5 3" v-if="pilih=='dokter' && this.vdata.id_pelanggan" style="font-size:12px;">
              <div class="shadow p-3 rounded-lg bg-white">
              <!-- INPUT -->
              <div class="sm-form">
                <input
                  type="text"
                  id="id"
                  name="id"
                  class="form-control form-control-sm"
                  placeholder="id"
                  v-model="vdata.id"
                  disabled
                />
              </div>
              <table class="table table-sm table-responsive">
              <!-- <tr>        
                <td class="capitalize">tanggal</td>
                <td class="pl-2 pr-2">:</td>
                <td colspan="4">
                    <div class="sm-form ">
                        <input required type="datetime-local" id="tanggal" name="tanggal" class="form-control form-control-sm" placeholder="tanggal" v-model="vdata.tanggal" >
                    </div>
                </td>
            </tr> -->
              <tr>        
                <td class="capitalize">(F1) barcode</td>
                <td class="pl-2 pr-2">:</td>
                <td colspan="4">
                  <select class='form-control' v-model="produkFilter">
                    <option value="8">Obat</option>
                    <option value="10">Jasa / Treatment</option>
                  </select>
                    <v-select id="f1" :options="tdProduk" label="item_data" v-model="vdata.id_produk" @input="cekstok();hitung_total()" :reduce="e => e.id"></v-select>
                </td>
            </tr>
              <tr>        
                <td class="capitalize">Jumlah</td>
                <td class="pl-2 pr-2">:</td>
                <td colspan="4">
                    <div class="sm-form ">
                        <input required type="number" @change="hitung_total" :disabled='stok==0' min="1" :max="stok" id="jumlah" name="jumlah" class="form-control form-control-sm" placeholder="jumlah" v-model="vdata.jumlah" >
                    </div>
                    <div class="float-right">
                        <button type="button" class="btn btn-sm btn-dark  " id="tambah" @click="kurang">(F2) -</button>
                        <button type="button" class="btn btn-sm btn-dark  " id="kurang" @click="tambah">(F3) +</button>
                    </div>
                    <p class="text-xs text-red-300">Stok sisa : {{stok}}</p>
                </td>
            </tr>
              <tr>        
                <td class="capitalize">harga</td>
                <td class="pl-2 pr-2">:</td>
                <td>
                    <div class="sm-form "  v-if="$store.state.users">
                        <input type="number" :disabled="$store.state.users.level!='SuperAdmin'" @change="hitung_total" id="harga" name="harga" class="form-control form-control-sm" placeholder="harga" v-model="vdata.harga" >
                    </div>
                </td>
                  <td class="capitalize">diskon</td>
                <td class="pl-2 pr-2">:</td>
                <td>
                    <div class="sm-form " v-if="$store.state.users">
                        <input type="number" :disabled="$store.state.users.level!='SuperAdmin'" @change="hitung_total" id="diskon" name="diskon" class="form-control form-control-sm" placeholder="diskon" v-model="vdata.diskon" >
                    </div>
                </td>
            </tr>
              <tr>        
                <td class="capitalize">total</td>
                <td class="pl-2 pr-2">:</td>
                <td class="font-bold text-lg" >
                    Rp. {{vdata.total}}
                </td>
                  <td class="capitalize">Satuan</td>
                <td class="pl-2 pr-2">:</td>
                <td class="text-xs" >
                    <div v-if="$store.state.users">
                      <v-select :options="satuans" :disabled="$store.state.users.level!='SuperAdmin'" label="satuan" v-model="vdata.satuan" @input="hitung_total()" :reduce="e => e.id"></v-select>
                    </div>
                </td>
            </tr>
              <!-- <tr>        
                <td class="capitalize">(F4) pelanggan</td>
                <td class="pl-2 pr-2">:</td>
                <td colspan="4">
                    <select id="selectpelanggan" class='form-control' v-model="vdata.id_pelanggan" @change="cekmembership">
                    <option v-for="(item, index) in pelanggans" :key="index+'pridils'" :value="item.id">{{item.nama}}</option>
                    </select>
                </td>
            </tr> -->
              <tr v-if="vdata.id_pelanggan">        
                <td class="capitalize">Membership</td>
                <td class="pl-2 pr-2">:</td>
                <td>
                  <span class="font-bold">
                    {{membership==0?'Bukan Membership':'Membership'}}
                  </span>
                  <span class="font-bold" v-if="membership==1">
                    <button type="button" class="btn btn-sm btn-primary  " @click="tambahDiskon">
                      {{diskon_membership}} %
                    </button>
                  </span>
                </td>
                <td class="capitalize">Total Beli Pelanggan</td>
                <td class="pl-2 pr-2">:</td>
                <td>
                  <span class="font-bold">
                    Rp. {{total_beli_pelanggan}}
                  </span>
                </td>
            </tr>
            </table>
              <!-- END INPUT -->
              <!-- BUTTON PART -->
              <div class="mt-3 p-3">
                <button
                  type="submit"
                  class="btn btn-sm"
                  id='btnsubmit'
                  :class="
                    btn == 'tambah'
                      ? 'btn-primary'
                      : btn == 'update'
                      ? 'btn-success'
                      : 'btn-danger'
                  "
                >
                  <span class="typcn typcn-info"></span> (F5) Proses {{ btn }}
                </button>
                <div class="float-right">
                  <button
                    type="button"
                    v-show="btn!='tambah'"
                    @click="
                    gantiBtn();
                      
                    "
                    class="btn btn-sm btn-dark"
                  >
                    <span class="typcn typcn-edit"></span> Tambah
                  </button>
                  <button
                    type="button"
                    @click="btn = 'delete'"
                    v-show="btn!='tambah'"
                    class="ml-3 btn btn-sm btn-danger"
                  >
                    <span class="typcn typcn-delete"></span> Delete
                  </button>
                </div>
              </div>
              </div>
              <!-- END BUTTON PART -->
            </div>
            <div class=" col-sm-7 p-2" style="font-size:12px;">
              <div class="shadow bg-white rounded-lg p-2" v-if="datanya.length>0">
                <div  class="">
                  <div v-if="pilih=='adminapotek'||pilih=='Admin'||pilih=='SuperAdmin'">
                    <button  type="button" id="btnbayar" @click="modalbayar=true" class="btn btn-sm btn-style9   waves-effect float-right text-xs"><span class="typcn typcn-export"></span> Bayar</button>
                    <button  type="button" @click="deleteAll" class="btn btn-sm btn-dark  "><span class="typcn typcn-eject"></span> Delete All</button>
                  </div>
                <br>
                <br>
                <p class="font-bold">Nota Transaksi : {{vdata.nota}}</p>
                    <Btables :tables="datanya"  :cari="['']" :hide="['id_produk','kategori','satuan','stok','keluar','id_user','tanggal_w','id_pelanggan']" @selected="ambil" ref="btable" />
                </div>
              </div>
            </div>
          
          </div>
        </form>
    </div>
    <!-- TABLE PART -->
    <!-- END TABLE PART -->
    <div style="height:200px;"></div>
  </div>
</template>

<script>
// TOTURIAL 
// ganti source autophp, ganti source component btable, ganti path table sdb
import autophp from "@/plugins/_autophp.js"; // ganti source nya
import Btables from "@/components/Btables.vue"; //component btable nya
let sdb = new autophp();
let sdb2 = new autophp();
import firebase from 'firebase'
import uniqid from 'uniqid'
let rdb=firebase.database()
import _ from 'lodash'
export default {
layout:'app_shop_admin',
  components: {
    Btables,
  },
  data() {
    return {
      pilih:'adminapotek',
      ticketType:'latest',
      nota:null,
      selected: false,
      modalbayar:false,
      modaltransaksi:false,
      proses:'',
      vdata: {
          jumlah:0,
          catatan_admin:''
      },
      produks:[],
      transaksiNota:[],
      pelanggans:[],
      ticket:null,
      btn: "tambah",
      stok:0,
      datanya:[],
      total:0,
      uang:'',
      diskons:false,
      skip_ambil_diskon:false,
      satuans:[],
      total_beli_pelanggan:0,
      membership:0,
      diskon_membership:0,
      produkFilter:8,
      updates:{}
    };
  },
  watch:{
    pilih(){
      this.getProduknya()
    }
  },
  computed:{
    tdProduk(){
      let that=this;
      let data =this.produks;
      data=data.filter(e=>{
        if(e.kategori==that.produkFilter){
          return e
        }
      })
      return data;
    }
  },
  methods: {
      updateTanggal(data){
        console.log(`update app_kasir_transaksi_nota set tanggal="${this.updates.tanggal}" where id='${data.id}'`)
        sdb.collection("app_kasir_transaksi_nota",false).doc().select(`update app_kasir_transaksi_nota set tanggal="${this.updates.tanggal}" where id='${data.id}'`).then(res => {
            console.log(res);
          sdb.alert('berhasil update','bg-green-400');
          window.location.reload();
        });
        
      },
      ubahTicket(item){
        this.ticketType=item;
        this.$forceUpdate();
      },
      getTicket(item){
        // console.log('item',item)
        this.ticket=item;
        this.vdata.nota=item.nota;
        this.proses=item.proses
        this.vdata.catatan_admin=item.catatan_admin;
        this.vdata.catatan_dokter=item.catatan_dokter;
        this.vdata.catatan_apoteker=item.catatan_apoteker;
        this.vdata.catatan_nurse=item.catatan_nurse;
        this.vdata.id_pelanggan=item.id_pelanggan
        this.cekmembership();
        this.getDatanya();
      },
      aktifModalTransaksi(){
        this.modaltransaksi=!this.modaltransaksi
        this.getNota();
      },  
      async tambahTransaksiBaru(){
        let that=this;
          if(this.vdata.id_pelanggan && this.vdata.catatan_admin){
            let data = this.datanya;
              data=data.map(e=>{
                  return e.id
              })
              let vdata={
                    total:0,
                    uang:0,
                    id_user:this.$store.state.users.id,
                    id_pelanggan:this.vdata.id_pelanggan,
                    tanggal_w:this.format(new Date(this.vdata.tanggal)),
                    cabang:this.$store.state.data.toko.cabang,
                    catatan_admin:this.vdata.catatan_admin,
                    nota:this.vdata.nota,
                    tanggal:this.vdata.tanggal,
                    proses:'1', // 1=kasir ,2=dokter, 3=apoteker, 4=nurse 
                    status:'1',
                    list_id:data.length>0?data.toString():'',
                    transaksi:'apotek',
                }
              
              sdb.collection("app_kasir_pelanggan",false).doc().select(`select * from app_kasir_pelanggan where id='${this.vdata.id_pelanggan}'`).then(async(res) => {
             
let txt=`
${that.vdata.nota}
${that.pilih.toUpperCase()} 
----------------------------
Pasien Baru Registered oleh Admin
Atas Nama : ${res[0].nama}
`;
that.sendNotif(txt,'Dokter');
that.sendNotif(txt,'Nurse');
that.sendNotif(txt,'Apoteker');
that.sendNotif(txt,'Admin');
              // axios.post('https://api.telegram.org/bot1524816097:AAEg9TRy49FIBAO2jsy_tGSUJjcqILL4Jbk/sendMessage',{ chat_id:"-572742884", text:txt }).then(res=>{ })
                sdb.collection('app_kasir_transaksi_nota').doc().set(vdata).then(res=>{
                    sdb.alert('Transaksi Berhasil ditambah!','bg-green-400');
                    that.modaltransaksi=false
                    that.getData();
                    that.getNota();
                })
              });
              
          }else{
            sdb.alert('Tambahkan pelanggan dan catatan terlebih dahulu!')
          }
          
      },
      async hapusTransaksi(item){
        // console.log('item',item)
        if(await sdb.confirm('Apakah yakin ingin menghapus data transaksi? ')){
            sdb.collection("app_kasir_transaksi_nota",true).doc(item.id).delete().then(async (res) => {
                sdb.collection("app_kasir_transaksi_nota",false).doc().select(`delete from app_kasir_transaksi_nota where nota='${item.nota}'`).then(res2 => {})
                this.getData();
                sdb.alert('Berhasil Delete data transaski!')
            }).catch(err=>{
              sdb.alert('Error menghapus data transaksi!')
            });
          }
      },
      async teruskanTransaksi(){
        if(this.proses=='3'||this.proses=='4'||this.proses=='5'||this.proses=='6'){
          sdb.alert('Tambahkan item/Jasa di transaksi,<br>  apabila ada item/jasa berbayar yang dilakukan!','bg-orange-400')
        }
        setTimeout(async () => {
          let that=this;
          if(this.proses.length>0){
            if(this.proses=='7' && this.datanya.length==0){
                alert('Data Transaksi tidak ada!');
                return;
            }
            if(confirm('Apakah yakin melanjutkan proses ? ')){
              let data={
                id:this.ticket.id,
                proses:this.proses,
                catatan_admin:this.vdata.catatan_admin,
                catatan_dokter:this.vdata.catatan_dokter,
                catatan_nurse:this.vdata.catatan_nurse,
                catatan_apoteker:this.vdata.catatan_apoteker,
              }
              // console.log(this.vdata)
              
              sdb.collection("app_kasir_pelanggan",false).doc().select(`select * from app_kasir_pelanggan where id='${this.vdata.id_pelanggan}'`).then(res2 => {
              
                sdb.collection('app_kasir_transaksi_nota').doc().set(data).then(async(res)=>{
                  rdb.ref('/ticket/admin').set({uniqid:uniqid()})
                
                  this.ticket=null;
                  var proses='';
                  if(that.proses=='1'){
                    proses=proses+`Pasien Baru Registered oleh Admin`;
                  }else if(that.proses=='2'){
                    proses=proses+`Permintaan Konsultasi ke Dokter`;
                  }else if(that.proses=='3'){
                    proses=proses+`Permintaan Treatment ke Nurse`;
                  }else if(that.proses=='4'){
                    proses=proses+`Permintaan Konsultasi ke Dokter`;
                  }else if(that.proses=='6'){
                    proses=proses+`Permintaan Menyiapkan Obat ke Apoteker`;
                  }else if(that.proses=='7'){
                  
                    proses=proses+`Permintaan Proses Pembayaran Ticket ke Admin`;
                  }
let target=that.proses=='2'||that.proses=='4'?'Dokter':that.proses=='3'?'Nurse':that.proses=='6'?'Apoteker':"Admin";                  
let txt=`
${that.vdata.nota}
${that.pilih.toUpperCase()} > ${target} 
----------------------------
${proses}
Atas Nama : ${res2[0].nama}
`;
// console.log(txt)
                  that.sendNotif(txt,target);
                  that.vdata={
                    jumlah:0,
                      catatan_admin:''
                  }
                  that.$forceUpdate();
                })
              });

            }
          }
        }, 800);
      },
      sendNotif(txt,target){
        let that=this;
        if(target=='Dokter'){ // GROUP DOKTER
          axios.post('https://api.telegram.org/bot1524816097:AAEg9TRy49FIBAO2jsy_tGSUJjcqILL4Jbk/sendMessage',{ chat_id:"-626593872", text:txt }).then(res=>{ 
            that.$forceUpdate();
          })
        }else if(target=='Nurse'){ // GROUP NURSE
          axios.post('https://api.telegram.org/bot1524816097:AAEg9TRy49FIBAO2jsy_tGSUJjcqILL4Jbk/sendMessage',{ chat_id:"-766394352", text:txt }).then(res=>{ 
            that.$forceUpdate();
          })
        }else if(target=='Apoteker'){ // GROUP APOTEKER
          axios.post('https://api.telegram.org/bot1524816097:AAEg9TRy49FIBAO2jsy_tGSUJjcqILL4Jbk/sendMessage',{ chat_id:"-739044142", text:txt }).then(res=>{ 
            that.$forceUpdate();
          })
        }else if(target=='Admin'){ // GROUP ADMIN
          axios.post('https://api.telegram.org/bot1524816097:AAEg9TRy49FIBAO2jsy_tGSUJjcqILL4Jbk/sendMessage',{ chat_id:"-796225318", text:txt }).then(res=>{ 
            that.$forceUpdate();
          })
        }
      },
      gantiBtn(){
        this.btn = 'tambah';
        let nota=this.vdata.nota
        let proses=this.proses ;
        let id_pelanggan=this.vdata.id_pelanggan;
        let catatan_admin=this.vdata.catatan_admin;
        let catatan_dokter=this.vdata.catatan_dokter;
        let catatan_nurse=this.vdata.catatan_nurse;
        let catatan_apoteker=this.vdata.catatan_apoteker;
        this.vdata = {
          nota:nota,
          jumlah:0,
          harga:0,
          id_pelanggan:id_pelanggan
        };
        this.vdata.catatan_admin=catatan_admin;
        this.vdata.catatan_dokter=catatan_dokter;
        this.vdata.catatan_nurse=catatan_nurse;
        this.vdata.catatan_apoteker=catatan_apoteker;
        this.skip_ambil_diskon=false;
        // this.getTanggal();
        // this.getNota();
      },
      async cekmembership(){
        let that=this;
        this.membership=await sdb.collection("app_kasir_pelanggan",false).doc().select(`select * from app_kasir_pelanggan where id=${this.vdata.id_pelanggan}`)
        this.membership=parseInt(this.membership[0].membership)
        let listmembership = await sdb.collection("app_kasir_pelanggan_membership",false).doc().select(`select * from app_kasir_pelanggan_membership`)
        let diskon
        this.total_beli_pelanggan=await sdb.collection("app_kasir_transaksi_nota",false).doc().select(`select * from app_kasir_transaksi_nota where id_pelanggan='${this.vdata.id_pelanggan}'`)
        this.total_beli_pelanggan=this.total_beli_pelanggan.reduce((e,n)=>{
          return e+(parseInt(n.total))
        },0)
        if(this.membership!=0){
          diskon=listmembership.filter(e=>{
            if(this.total_beli_pelanggan>parseInt(e.total_beli)){
              return e
            }
          })
          if(diskon.length>0){
            this.diskon_membership=parseInt(diskon[0].diskon)
          }
        }
        // console.log(this.vdata.id_pelanggan,this.total_beli_pelanggan)
        this.$forceUpdate();        
        
      },
      tambahDiskon(){
        this.vdata.diskon=parseInt(this.vdata.diskon)+parseInt(this.diskon_membership)
        this.hitung_total();
        this.$forceUpdate();
      },
      async tambahPointPelanggan(){
        if(parseInt(this.getJam())<16){ // jam pagi
          let data={}
          data.id = this.vdata.id_pelanggan
          let pelanggan=await sdb.collection("app_kasir_pelanggan",false).doc().select(`select * from app_kasir_pelanggan where id=${this.vdata.id_pelanggan}`)
          data.point=parseInt(pelanggan[0].point)+25
          // console.log('data pelanggan',data)
          sdb.collection('app_kasir_pelanggan').doc().set(data).then(res=>{
              // console.log(res)
          })
        }else if(parseInt(this.getJam())>16){ // jam sore/malam
           let data={}
          data.id = this.vdata.id_pelanggan
          let pelanggan=await sdb.collection("app_kasir_pelanggan",false).doc().select(`select * from app_kasir_pelanggan where id=${this.vdata.id_pelanggan}`)
          data.point=parseInt(pelanggan[0].point)+35
          // console.log('data pelanggan',data)
          sdb.collection('app_kasir_pelanggan').doc().set(data).then(res=>{
              // console.log(res)
          })
        }
    
      },
      tambah(){
        if(this.vdata.jumlah>parseInt(this.stok)-1){
          
          }else{
            this.vdata.jumlah=parseInt(this.vdata.jumlah)+1;
            this.hitung_total()
          }
      },
      kurang(){
        if(this.vdata.jumlah<1){

        }else{
          this.vdata.jumlah=parseInt(this.vdata.jumlah)-1;
          this.hitung_total()
        }
      },
      format(tanggal) {
        return this.$datefns.format(new Date(tanggal),"YYYY-MM-DD");
      },
      format2(tanggal) {
        return this.$datefns.format(new Date(tanggal),"YYYY-MM-DD HH:mm");
      },
      format3(tanggal) {
        return this.$datefns.format(new Date(tanggal),"DD-MM-YYYY");
      },
      getJam(tanggal) {
        return this.$datefns.format(new Date(),"HH");
      },
      getNota(){
          let code='KA';//KA = kasir, ON=Online, OF=OFFLINE
          sdb.collection("app_kasir_transaksi_nota").doc().get("*",`where id_user='${this.$store.state.users.id}' order by id`).then(res => {
              this.vdata.nota=code+this.format(new Date()).split('-').join('')+'-'+this.$store.state.users.id+'-'+res.length;
              // console.log('nota',this.vdata.nota)
              this.$forceUpdate();
          });
      },
     async cekstok(item){
        // console.log(this.vdata)
          let stok=await sdb.collection("app_kasir_produk").doc().get("*",`where id='${this.vdata.id_produk}' order by id`).then(res => {
         if(!this.skip_ambil_diskon){
             this.vdata.diskon=res[0].diskon
         }
          this.vdata.harga=res[0].harga
          this.vdata.satuan=res[0].satuan
        return parseInt(res[0].stok)
      });
      let masuk = await sdb.collection("app_kasir_stok_masuk").doc().get("*",`where id_produk='${this.vdata.id_produk}' order by id`).then(res => {
        return res.reduce((e,n)=>{
          return e+parseInt(n.jumlah)
        },0)
      });
      let keluar = await sdb.collection("app_kasir_stok_keluar").doc().get("*",`where id_produk='${this.vdata.id_produk}' order by id`).then(res => {
        return res.reduce((e,n)=>{
          return e+parseInt(n.jumlah)
        },0)
      });
      
      // let transaksi=await sdb.collection("app_kasir_transaksi_nota",false).doc().select(`SELECT * FROM app_kasir_transaksi_nota tb1 left join app_kasir_keranjang tb2 on tb1.nota=tb2.nota where tb2.id_produk='${this.vdata.id_produk}' order by tb1.id`).then(res => {
      //      return res.reduce((e,n)=>{
      //       return e+parseInt(n.jumlah)
      //       },0)
      // });
       let keranjang=await sdb.collection("app_kasir_keranjang",false).doc().select(`SELECT * FROM app_kasir_keranjang  tb1 where tb1.id_produk='${this.vdata.id_produk}' order by tb1.id`).then(res => {
           return res.reduce((e,n)=>{
            return e+parseInt(n.jumlah)
            },0)
      });
      stok=stok+(masuk-keluar-keranjang)
      this.stok=stok;
      this.hitung_total();
      this.$forceUpdate();
    },
    hitung_diskon(){
        let data= this.datanya;
        if(data.length>0){
            this.total=data.reduce((e,n)=>{
                let diskon = (parseInt(n.diskon)/100)*parseInt(n.harga)
                return e+((parseInt(n.harga)*parseInt(n.jumlah))-diskon)
            },0)
            this.diskons=true;
        }
        this.$forceUpdate();
    },
    hitung_total(){
      // console.log('satuans',this.satuans)
        let satuan=parseInt(this.satuans.filter(e=>e.id==this.vdata.satuan)[0].perkalian)
        this.vdata.total=(parseInt(this.vdata.harga)*satuan)*this.vdata.jumlah-((parseInt(this.vdata.diskon)/100)*parseInt(this.vdata.harga)*this.vdata.jumlah)
        this.$forceUpdate();
    },
    deleteAll(){
        if(confirm('apakah yakin menghapus semua data?')){
            let ids = [];
            ids=this.datanya.map(e=>e.id_user);
            sdb.collection("app_kasir_keranjang",false).doc().select(`DELETE FROM app_kasir_keranjang WHERE id_user IN (${ids.toString()}) AND posisi='keranjang'`).then(res => {
                // console.log(res);
                this.getData();
            });
        }
    },
    deleteAll2(){
            let ids = [];
            ids=this.datanya.map(e=>e.id_user);
            sdb.collection("app_kasir_keranjang",false).doc().select(`DELETE FROM app_kasir_keranjang WHERE id_user IN (${ids.toString()}) AND posisi='keranjang'`).then(res => {
                // console.log(res);
                this.getData();
            });
    },
    getDatanya(){
      sdb.collection("app_kasir_keranjang",false).doc().select(`
      select tb1.id,tb1.id_user,tb1.nota,tb1.tanggal,tb1.id_pelanggan,tb3.nama,tb2.barcode,tb1.harga,tb1.jumlah,tb2.nama_produk,tb1.id_produk,tb1.diskon,tb1.total,tb1.tanggal_w
      from app_kasir_keranjang tb1 left join app_kasir_produk tb2 on tb2.id=tb1.id_produk left join app_kasir_pelanggan tb3 on tb3.id=tb1.id_pelanggan where tb1.nota='${this.vdata.nota}'`).then(res => {
        this.datanya=res;
        if(res.length>0){
            this.total=res.reduce((e,n)=>{
                return e+(parseInt(n.total))
            },0)
            let date = this.format(new Date()).split('-')[2]
            if(res[0].tanggal_w.split('-')[2]==date){
            }else{
                setTimeout(() => {
                    this.deleteAll2();
                }, 1000);
            }
            this.hitung_total();
        }
        this.$forceUpdate();
      });
    },
    getProduknya(){
      var type='1';
      // if(this.pilih=='dokter' || this.pilih=='nurse'){
      //   type='3'
      // }
      sdb.collection("app_kasir_produk").doc().get("*",` order by id`).then(res => {
          this.produks=res;
          this.produks.map(function (x){ // taruh setelah produks di initial
                return x.item_data = x.barcode + ' / ' + x.nama_produk;
          });
      });
    },
    getData(){
      this.getDatanya();
      this.getProduknya();
       sdb.collection("app_kasir_pelanggan").doc().get("*","order by id").then(res => {
          this.pelanggans=res;
          this.pelanggans.map(function (x){ // taruh setelah produks di initial
                  return x.item_data = x.nama + ' / ' + x.nohp;
          });
          this.$forceUpdate();
      });
      sdb.collection("app_kasir_transaksi_nota",false).doc().select(`
      select tb1.nota,tb1.id,tb1.tanggal,tb1.proses,tb2.id as id_pelanggan,tb2.nama as pelanggan,tb3.username as penginput,tb1.catatan_admin,tb1.catatan_dokter,tb1.catatan_apoteker,tb1.catatan_nurse from app_kasir_transaksi_nota tb1 left join app_kasir_pelanggan tb2 on tb2.id=tb1.id_pelanggan left join tbuser tb3 on tb3.id=tb1.id_user
      where tb1.status!='delete' order by id asc
      `).then(res => {
        this.transaksiNota=res;
        // console.log('transaksinota',res)
        this.$forceUpdate();
      });
    
      
      
    },
    ambil(data) {
      let proses=this.proses ;
      let catatan_admin=this.vdata.catatan_admin;
      let catatan_dokter=this.vdata.catatan_dokter;
      let catatan_nurse=this.vdata.catatan_nurse;
      let catatan_apoteker=this.vdata.catatan_apoteker;
      this.vdata = data;
      this.vdata.catatan_admin=catatan_admin;
      this.vdata.catatan_dokter=catatan_dokter;
      this.vdata.catatan_nurse=catatan_nurse;
      this.vdata.catatan_apoteker=catatan_apoteker;
      this.cekstok();
      this.skip_ambil_diskon=true;
      // console.log(data)
      this.btn = "update";
      this.$forceUpdate();
    },
    async bayar(){
      let that=this
      if(this.uang==0){
        alert('Uang tidak boleh 0')
      }else if(this.uang<this.total){
        alert('Uang tidak boleh kurang dari total harga')
      }
      else{
        if(confirm('Apakah yakin di proses ?')){
           let data = this.datanya;
            data=data.map(e=>{
                return e.id
            })
          let vdata={
            total:this.total,
            uang:this.uang,
            id_user:this.$store.state.users.id,
            id_pelanggan:this.datanya[0].id_pelanggan,
            tanggal_w:this.datanya[0].tanggal_w,
            cabang:this.$store.state.data.toko.cabang,
            keterangan:this.vdata.keterangan,
            nota:this.vdata.nota,
            tanggal:this.vdata.tanggal,
            status:'3',
            proses:'8',
            list_id:data.toString(),
          }
            let ids = [];
            ids=this.datanya.map(e=>e.id_user);
            sdb.collection("app_kasir_transaksi_nota",false).doc().select(`select * from app_kasir_transaksi_nota where nota='${this.vdata.nota}'`).then(async(res)=> {
let cttn =`
NOTA : ${that.vdata.nota} <br/>
TANGGAL : ${that.format3(new Date())} <br/>
============================ <br/>
Catatan ADMIN <br/>
${res[0].catatan_admin}  <br/>
============================ <br/>
Catatan Dokter <br/>
${res[0].catatan_dokter}  <br/>
============================ <br/>
Catatan Nurse <br/>
${res[0].catatan_nurse}  <br/>
============================ <br/>
Catatan Apoteker <br/>
${res[0].catatan_apoteker}  <br/>
============================ <br/>
`;
              await sdb.collection('app_kasir_pelanggan_history').doc().set({
                pelanggan:that.vdata.id_pelanggan,
                tanggal:new Date(),
                create_by:that.$store.state.users.username,
                catatan:cttn,
                id_transaksi_nota:that.vdata.nota
              })
              vdata.id=res[0].id;

              sdb2.collection('app_kasir_transaksi_nota').doc().set(vdata).then(res=>{
                sdb.collection("app_kasir_keranjang",false).doc().select(`update app_kasir_keranjang set posisi='nota' WHERE id_user IN (${ids.toString()}) AND posisi='keranjang'`).then(res=>{
                    // that.tambahPointPelanggan()
                    that.$router.push(`/admin/report/transaksi_now?nota=${that.vdata.nota}`)
                })
              })
            });
            
        }
      }
    },
    async submit() {
      let that=this
      this.getTanggal()
      if(this.vdata.id_produk && parseInt(this.vdata.jumlah)>0 && this.vdata.id_pelanggan){
         let vdata={
           status:'keluar',
           tanggal_w:this.format(new Date(this.vdata.tanggal)),
           id_user:this.$store.state.users.id,
           posisi:'keranjang',
           beli:'kasir',
           cabang:this.$store.state.data.toko.cabang,
           diskon:this.vdata.diskon,
           harga:this.vdata.harga,
           id_pelanggan:this.vdata.id_pelanggan,
           id_produk:this.vdata.id_produk,
           jumlah:this.vdata.jumlah,
           tanggal:this.vdata.tanggal,
           nota:this.vdata.nota,
           total:this.vdata.total,
           satuan:this.vdata.satuan,
           catatan_admin:this.vdata.catatan_admin,
            catatan_dokter:this.vdata.catatan_dokter,
            catatan_nurse:this.vdata.catatan_nurse,
            catatan_apoteker:this.vdata.catatan_apoteker,
         }
          let cek = this.datanya.filter(e=>{
            if(e.id==that.vdata.id_produk){
              return e
            }
          })
          if (confirm("Apakah yakin proses dilanjutkan ?")) {
            if (this.btn == "tambah") {
              delete this.vdata.id;
             await sdb
                .collection("app_kasir_keranjang")
                .doc()
                .set(vdata)
                  that.getData();
                  that.cekstok();
                  let nota=that.vdata.nota;
                  let id_pelanggan=that.vdata.id_pelanggan
                  that.vdata= {
                    jumlah:0,
                    nota:nota,
                    id_pelanggan:id_pelanggan,
                    catatan_admin:vdata.catatan_admin,
                    catatan_dokter:vdata.catatan_dokter,
                    catatan_nurse:vdata.catatan_nurse,
                    catatan_apoteker:vdata.catatan_apoteker,
                  }
                  that.getTanggal();
    
            } else if (this.btn == "update") {
              vdata.id=this.vdata.id
              await sdb
                .collection("app_kasir_keranjang")
                .doc()
                .set(vdata)
                  that.getData();
                  that.cekstok();
                   let nota=that.vdata.nota;
                  let id_pelanggan=that.vdata.id_pelanggan
                  that.vdata= {
                    jumlah:0,
                    nota:nota,
                    id_pelanggan:id_pelanggan,
                    catatan_admin:vdata.catatan_admin,
                    catatan_dokter:vdata.catatan_dokter,
                    catatan_nurse:vdata.catatan_nurse,
                    catatan_apoteker:vdata.catatan_apoteker,
                  }
                  that.getTanggal();
            } else if (this.btn == "delete") {
              await sdb
                .collection("app_kasir_keranjang")
                .doc(this.vdata.id)
                .delete()
                  that.getData();
                  that.cekstok();
                    let nota=that.vdata.nota;
                  let id_pelanggan=that.vdata.id_pelanggan
                  that.vdata= {
                    jumlah:0,
                    nota:nota,
                    id_pelanggan:id_pelanggan,
                    catatan_admin:vdata.catatan_admin,
                    catatan_dokter:vdata.catatan_dokter,
                    catatan_nurse:vdata.catatan_nurse,
                    catatan_apoteker:vdata.catatan_apoteker,
                  }
                  that.getTanggal();
            }
          }
      }else{
        sdb.alert('Isi Barcode, Jumlah, dan data pelanggan terlebih dahulu!')
      }
    },
    getTanggal(){
        this.vdata.tanggal=this.$datefns.format(new Date(),"YYYY-MM-DDTHH:mm")
    },
    getSatuan(){
      sdb.collection("app_kasir_produk_satuan").doc().get("*","order by id").then(res => {
          this.satuans=res;
          this.$forceUpdate();
      });
      
    }
  },
  async mounted() {
     this.vdata= {
          jumlah:0,
          catatan_admin:''
     }
    this.pilih=this.$store.state.users.level
    let that=this;
     rdb.ref(`/scan/${that.$store.state.users.id}/barcode`).on('value',(e)=>{ //read
          if(that.produks.length>0){
            // console.log('produks',that.produks)
            let data =that.produks.filter(k=>{
              // console.log(k.barcode)
              if(k.barcode==e.val().id){
                return k
              }
            })
            // console.log(data)
            that.vdata.id_produk=data[0].id
            that.cekstok();
            that.$forceUpdate();
          }
    }) 
    rdb.ref(`/ticket/admin`).on('value',(e)=>{ //read
        that.getData();
    }) 
      setTimeout(() => {
        // this.getNota();
        this.getData();
        this.getSatuan();
    }, 1000);
    this.getTanggal();
      document.addEventListener('keydown',function(e){
        if(e.key=='+' || e.key=='='){
          that.tambah()
        }else if(e.key=='-'){
          that.kurang()
        }
        if(e.key=='F1'){
          e.preventDefault()
          that.$el.querySelector('.vs__search').focus();
        }else if(e.key=='F2'){
          e.preventDefault();
          that.kurang()
        }else if(e.key=='F3'){
          e.preventDefault();
          that.tambah()
        }else if(e.key=='F4'){
          e.preventDefault();
          that.$el.querySelector('#selectpelanggan').focus();
        }else if(e.key=='F5'){
          e.preventDefault();
          that.$el.querySelector('#btnsubmit').click();
        }else if(e.key=='F6'){
          e.preventDefault();
          that.$el.querySelector('#btnbayar').click();
          setTimeout(() => {
            that.$el.querySelector('#uang').focus();
          }, 2000);
        }else if(e.key=='F7'){
          e.preventDefault();
          that.$el.querySelector('#keterangan').focus();
        }else if(e.key=='F8'){
          e.preventDefault();
          that.$el.querySelector('#btnbayar2').click();
        }
      })
        const slider = document.querySelector('.items');
        let isDown = false;
        let startX;
        let scrollLeft;
        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            slider.classList.add('active');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mousemove', (e) => {
            if(!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 3; //scroll-fast
            slider.scrollLeft = scrollLeft - walk;
        });
  },
};
</script>